import { useEffect } from 'react';

import { cssVarTableHeight } from '../../wrappers/charlie-table-dnd-wrapper';

type UseTableHeightEffectArgs = {
	tableRef: React.RefObject<HTMLTableElement>;
};

/**
 * Sets up a ResizeObserver to keep the CSS variable for table height up to date.
 */
export const useTableHeightEffect = ({ tableRef }: UseTableHeightEffectArgs) => {
	useEffect(() => {
		const table = tableRef.current;
		if (!table) {
			return;
		}

		const resizeObserver = new ResizeObserver((entries) => {
			for (const { contentBoxSize } of entries) {
				if (!contentBoxSize) {
					return;
				}

				const [{ blockSize }] = contentBoxSize;

				// subtracting 1 to prevent an overflow from happening
				table.style.setProperty(cssVarTableHeight, `${blockSize - 1}px`);
			}
		});

		resizeObserver.observe(table);

		return () => {
			resizeObserver.disconnect();
		};
	}, [tableRef]);
};
